<template>
  <v-container ref="copyContainer" grid-list-xl fluid>
    <v-layout row wrap>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex v-if="!pageLoading">
        <filter-sources-stats
          :default-search-params="searchParams"
          :is-component-loading="isRequestingNow"
          @filtering="onFilter"
          @download-excel="onDownloadExcel"
        ></filter-sources-stats>
        <div v-if="data" style="max-width: 100%; overflow-x: auto;">
          <table id="customers">
            <thead>
            <tr>
              <th :key="item.value" v-for="item in headers">
                {{item.text}}
              </th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(item, index) in data">
            <tr v-if="ORDER_SOURCES.includes(item.source)"  :key="item.source+'-'+index">
              <td>{{ lang($store, `sap/listings.global.filter.sources.` + item.source) }}</td>
              <td>{{item.orders_base}}
                <small>{{ computedValue(item.orders_base, allSumm.orders_base).toFixed(2)}}%</small>

              </td>
              <td>{{item.orders_complex}}
                <small>{{ computedValue(item.orders_complex, allSumm.orders_complex).toFixed(2)}}%</small>
              </td>
              <td>{{item.dry_cleaning}}
                <small>{{ computedValue(item.dry_cleaning, allSumm.dry_cleaning).toFixed(2)}}%</small>

              </td>
              <td>{{item.sum}}
                <small>{{ computedValue(item.sum, allSumm.sum).toFixed(2)}}%</small>
              </td>
            </tr>
            </template>
            <tr class="bolder-row">
              <td><b>{{ $t('table.headers.sum') }}</b></td>
              <td>{{allSumm.orders_base}}</td>
              <td>{{allSumm.orders_complex}}</td>
              <td>{{allSumm.dry_cleaning}}</td>
              <td>{{allSumm.sum}}</td>
            </tr>
            </tbody>
          </table>
          <!-- <v-data-table
             :headers="headers"
             :items="data"
             :items-per-page="300"
             item-key="name"
             class="elevation-1"
             :footer-props="{'disable-items-per-page': true}"
           />-->
        </div>
      </v-flex>
      <modal-loading :is-show="isTableLoading"></modal-loading>
    </v-layout>
  </v-container>
</template>

<script>
import i18n from '@/i18n';
/* constants */
import downloadReport from '@/mixins/reports/downloadReport';
import StatsOrdersProxy from '@/proxies/Stats/StatsOrdersProxy';
import { MAIN_SOURCES as ORDER_SOURCES } from '~constants/sources';
import { MANAGER_TOP } from '@/constants/roles';
/* mixins */
import defaultListingMixin from '../../mixins/listing/defaultListingMixin';
import updatePageContentMixin from '../../mixins/updatePageContentMixin';
/* components */
import ModalLoading from '../../components/loaders/ModalLoading.vue';
import FilterSourcesStats from '../../components/listings/FilterSourcesStats.vue';


export default {
  name: 'SourcesStats',
  mixins: [
    updatePageContentMixin,
    defaultListingMixin,
    downloadReport,
  ],
  components: {
    ModalLoading,
    FilterSourcesStats,
  },
  data() {
    return {
      MANAGER_TOP,
      ORDER_SOURCES,
      /* Page management */
      pageLoading: false,
      /* Listing management */
      isTableLoading: false,
      searchParams: {
        from: null,
        to: null,
        region: null,
        statuses: [],
        sources: JSON.parse(JSON.stringify(this.initSources())),
      },
      data: null,
      headers: [
        {
          text: i18n.t('table.headers.source_title'),
          align: 'left',
          sortable: true,
          value: 'source_title',
        },
        {
          text: i18n.t('table.headers.orders_base'),
          value: 'orders_base',
        },
        {
          text: i18n.t('table.headers.orders_complex'),
          value: 'orders_complex',
        },
        {
          text: i18n.t('table.headers.dry_cleaning'),
          value: 'dry_cleaning',
        },
        {
          text: i18n.t('table.headers.sum'),
          value: 'sum',
        },
      ],
    };
  },
  computed: {
    /* store */
    account() {
      return this.$store.getters['account/account'];
    },
    allSumm() {
      const allSumm = {
        orders_base: 0,
        subscriptions: 0,
        orders_complex: 0,
        dry_cleaning: 0,
        sum: 0,
      };
      this.data.forEach((item) => {
        allSumm.orders_base += item.orders_base;
        allSumm.orders_complex += item.orders_complex;
        allSumm.dry_cleaning += item.dry_cleaning;
        allSumm.sum += item.sum;
      });
      return allSumm;
    },
  },
  methods: {
    fetchData() {
      new StatsOrdersProxy()
        .setParameters(this.searchParams)
        .bySources()
        .then((response) => {
          this.data = response.data.data.stats;
        })
        .catch((error) => {
          this.data = null;
          console.log(error);
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
    computedValue(a, b) {
      if (a === 0) {
        return 0;
      }
      return (a / b * 100);
    },
    initSources() {
      const values = [];
      ORDER_SOURCES.forEach(($item) => values.push($item));
      return values;
    },
  },
};
</script>

<style>
  #customers {
    font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
    border-collapse: collapse;
    width: 100%;
    font-size: 12px;
  }

  #customers td, #customers th {
    border: 1px solid #ddd;
    padding: 8px;
  }

  #customers tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  #customers tr:hover {
    background-color: #ddd;
  }

  #customers th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    background-color: #4CAF50;
    color: white;
  }

  #customers tr.bolder-row {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    background-color: #af5149;
    color: white;
  }
</style>
